import key from './key'

const actionTypes = {
  CREATE_EVENT: `${key}/CREATE_EVENT`,
  UPLOAD_EVENTS: `${key}/UPLOAD_EVENTS`
}

export default actionTypes
